module.exports.UsaGroupUuid = '3c517d70-172e-11ed-861d-0242ac120002';
module.exports.WorldGroupUuid = '05e1ba88-1734-11ed-861d-0242ac120002';
module.exports.UsaGroupId = 'us-consolidated';
module.exports.WorldGroupId = 'worldwide-consolidated';

module.exports.UsaJurisdictionId = 'ad0923c7-d2ab-11eb-8d16-37857b20c904';

module.exports.ReportType = {
  MultiEntity: 'multi-entity',
  SingleEntity: 'single-entity',
  SingleEntityState: 'single-entity-state',
};

exports.ReportModelTypes = {
  SingleEntityState: 'SingleEntityState',
  SingleEntityStateTotals: 'SingleEntityStateTotals',
  SingleEntityFederal: 'SingleEntityFederal',
  MultiEntityTotals: 'MultiEntityTotals',
  MultiEntityStateTotals: 'MultiEntityStateTotals',
  MultiEntityFederalTotals: 'MultiEntityFederalTotals'
};

exports.AuditTrail = {
  datatypeIdsByName: {
    entityFinancials: 1
  },
  actionIdsByName: {
    create: 1,
    update: 2,
    delete: 3
  },
  inputTypeIdByName: {
    manual: 1,
    uploadedByTrialBalance: 2,
    additionalImports: 3
  }
};

const stateStepsByName = {
  rtp: 'rtp',
  apportionment: 'apportionment',
  modificationsPermanent: 'modifications.permanent',
  modificationsTemporary: 'modifications.temporary',
  nol: 'nol',
  credits: 'credits',
  taxEffected: 'tax-effected',
  deferred: 'deferred',
  accounts: 'accounts'
};

const federalStepsByName = {
  rtp: 'rtp',
  ptbi: 'ptbi',
  permanent: 'permanent',
  temporaryBalanceSheet: 'temporary.balanceSheet',
  temporaryIncomeStatement: 'temporary.incomeStatement',
  nol: 'nol',
  credits: 'credits',
  taxEffected: 'tax-effected',
  deferred: 'deferred',
  accounts: 'accounts',
};

const discreteStepsByName = {
  adjustment: 'adjustment'
};

exports.UiTabs = {
  state: {
    ...stateStepsByName
  },
  federal: {
    ...federalStepsByName
  },
  discrete: {
    ...discreteStepsByName
  },
};

exports.Reports = {
  BeginningStateEtr: { Name: 'beginning-state-etr', Key: 'BeginningStateEtr' },
  CurrentStateEtr: { Name: 'current-state-etr', Key: 'CurrentStateEtr' },
  EndStateEtr: { Name: 'end-state-etr', Key: 'EndStateEtr' },
  StateCurrentProvision: { Name: 'state-current-provision', Key: 'StateCurrentProvision' },
  StateRtp: { Name: 'state-rtp', Key: 'StateRtp' },
  FederalCurrentProvision: { Name: 'federal-current-provision', Key: 'FederalCurrentProvision' },
  DeferredGross: { Name: 'deferred-gross', Key: 'DeferredGross' },
  DeferredFederal: { Name: 'deferred-federal', Key: 'DeferredFederal' },
  DeferredStateFbos: { Name: 'deferred-state-fbos', Key: 'DeferredStateFbos' },
  DeferredState: { Name: 'deferred-state', Key: 'DeferredState' },
  DeferredFbos: { Name: 'deferred-fbos', Key: 'DeferredFbos' },
  DeferredFedStateFbos: { Name: 'deferred-fed-state-fbos', Key: 'DeferredFedStateFbos' },
  RateReconciliationSummary: { Name: 'rate-reconciliation-summary', Key: 'RateReconciliationSummary' },
  RateReconciliationDetail: { Name: 'rate-reconciliation-detail', Key: 'RateReconciliationDetail' },
  FederalRtp: { Name: 'federal-rtp', Key: 'FederalRtp' },
  TaxAccountRollforward: { Name: 'tax-account-rollforward', Key: 'TaxAccountRollforward' },
  FederalCurrentProvisionStateTaxDeductionRtp: { Name: 'federal-current-provision-state-tax-deduction-rtp', Key: 'FederalCurrentProvisionStateTaxDeductionRtp' },
  Summary: { Name: 'summary', Key: 'Summary' }
};

exports.HttpCodes = {
  Success: 200,
  SuccessCreate: 201,
  Accepted: 202,
  BadRequest: 400,
  UnprocessableEntity: 422,
  CognitoError: 423,
  InternalServerError: 500
};

exports.Methods = {
  Post: 'POST',
  Patch: 'PATCH',
  Get: 'GET',
  Put: 'PUT',
  Delete: 'DELETE',
  Options: 'OPTIONS',
  Any: 'ANY'
};